import { render, staticRenderFns } from "./InsightsView.vue?vue&type=template&id=93c3719e"
import script from "./InsightsView.vue?vue&type=script&lang=js"
export * from "./InsightsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports